import { Document } from "../types";
import { SIGNING_UNAVAILABLE_REASON } from "../constants";

export const mappingUnsignedDocuments = (documents: Document[]): Document[] =>
  documents.map((document) => {
    switch (document.systemShortName) {
      case "monolith":
        break;

      case "monolit":
        document.systemShortName = "monolith";
        break;

      default:
        document.systemShortName = "ms";
        break;
    }

    document.signingUnavailableReasonText = document.signingUnavailableReason
      ? SIGNING_UNAVAILABLE_REASON[document.signingUnavailableReason]
      : "";
    document.type.transactionType = document.type.transactionType || "";
    document.contragent.name = document.contragent.name || "";
    document.contragent.account = document.contragent.account || "";

    return document;
  });
